
import { afterNextRender, ChangeDetectionStrategy, Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { Product } from '../../domain/product';
import { ProductService } from './product.service';
import { SITE_TITLE } from '../../shared/constants';

@Component({
  selector: 'app-products',
  imports: [
    RouterModule
],
  templateUrl: './products.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './products.component.scss'
})
export class ProductsComponent implements OnInit, OnDestroy {
  private revealObserver?: IntersectionObserver;

  constructor(
    private meta: Meta, private title: Title,
    private router: Router,
    private elementRef: ElementRef<HTMLElement>,
    private productsService: ProductService) {
    // afterNextRender so this only runs in the browser, after hydration has settled.
    afterNextRender(() => this.setupRevealObserver());
  }

  products: Product[] = []

  ngOnInit(): void {
    this.title.setTitle(SITE_TITLE + ' | Our Products');
    this.meta.updateTag({ name: 'description', content: 'BunnyCRM gives teams connected modules for marketing, sales, support, and documents — all built around one customer record.' });
    this.meta.updateTag({ name: 'keywords', content: 'Products, Products catalogue, BunnyCRM, BunnyCRM Sales, BunnyCRM Marketing, BunnyCRM Support, BunnyCRM Notes, BunnyCRM Action Items, BunnyCRM Drive' });

    this.products = this.productsService.getProducts()
  }

  private setupRevealObserver(): void {
    this.revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          this.revealObserver?.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    this.elementRef.nativeElement
      .querySelectorAll<HTMLElement>('[data-reveal]')
      .forEach(el => this.revealObserver?.observe(el));
  }

  ngOnDestroy(): void {
    this.revealObserver?.disconnect();
  }

  routeTo(path: string) {
    this.router.navigate([path]);
  }
}
